import React from 'react'

import { useTranslation } from 'react-i18next'

import chevron from '../assets/icons/chevron.svg'
import { findSmallestOrLargestMeasurement } from '../helpers'
import quizStyles from '../styles/CalculatorQuiz.module.css'

const MeasurementInput = ({
  inputMeasurement,
  onChangeFunction,
  inchesCharts,
  chart,
  setSmaller,
  setLarger,
  bandSizes = undefined,
  bandSize = undefined,
  getRange = undefined,
}) => {
  const { t } = useTranslation()

  // Helper function to trim .00 and .50 from display values
  const trimDisplayValue = (value) => {
    if (!inchesCharts.includes(chart)) return value
    if (value.endsWith('.00')) return value.replace('.00', '')
    if (value.endsWith('.50')) return value.replace('.50', '.5')
    return value
  }
  const smallestValue = getRange
    ? inchesCharts.includes(chart)
      ? 32.25
      : 82
    : findSmallestOrLargestMeasurement(bandSizes)
  const largestValue = getRange
    ? inchesCharts.includes(chart)
      ? 64.25
      : 163
    : findSmallestOrLargestMeasurement(bandSizes, 'desc')

  const generateOptions = () => {
    if (getRange && bandSize) {
      const options = []
      for (let i = smallestValue; i <= largestValue; inchesCharts.includes(chart) ? (i += 0.25) : (i += 1)) {
        options.push(
          <option key={i} value={inchesCharts.includes(chart) ? trimDisplayValue(i.toFixed(2)) : i}>
            {(() => {
              if (inchesCharts.includes(chart)) {
                const displayValue = trimDisplayValue(i.toFixed(2))
                return `${displayValue} in`
              }
              return `${i} cm`
            })()}
          </option>
        )
      }
      return options
    } else if (bandSizes) {
      const options = Object.keys(bandSizes)
        .sort((a, b) => a - b)
        .map((key, i) => {
          // Apply same trimming logic as bust measurements
          const trimmedValue = trimDisplayValue(key)
          return (
            <option key={i} value={trimmedValue}>
              {trimmedValue} {['uk', 'us'].includes(chart) ? ' in' : ' cm'}
            </option>
          )
        })
      return options
    }
  }

  const onChangeHandler = (e) => {
    onChangeFunction(e.target.value)
    if (e.target.value.includes('<')) {
      setSmaller(true)
      setLarger(false)
    } else if (e.target.value.includes('>')) {
      setSmaller(false)
      setLarger(true)
    } else {
      setSmaller(false)
      setLarger(false)
    }
  }

  return (
    <>
      <div className={quizStyles['select-wrapper']}>
        <p className={quizStyles['selected-value']}>
          {inputMeasurement &&
            (() => {
              const displayValue = trimDisplayValue(inputMeasurement)
              return displayValue + (inchesCharts.includes(chart) ? ' in' : ' cm')
            })()}
          {!inputMeasurement && t('select_measurement')}
        </p>
        <img src={chevron} alt="chevron" className={quizStyles.chevron} />
        <select className={quizStyles.select} onChange={onChangeHandler} value={inputMeasurement || ''}>
          <option value="" disabled hidden>
            {t('select_measurement')}
          </option>
          <option value={'< ' + trimDisplayValue(smallestValue.toString())}>
            {(() => {
              const displaySmallest = trimDisplayValue(smallestValue.toString())
              return ` < ${displaySmallest} ${['uk', 'us'].includes(chart) ? ' in' : ' cm'}`
            })()}
          </option>
          {generateOptions()}
          <option value={'> ' + trimDisplayValue(largestValue.toString())}>
            {(() => {
              const displayLargest = trimDisplayValue(largestValue.toString())
              return ` > ${displayLargest} ${['uk', 'us'].includes(chart) ? ' in' : ' cm'}`
            })()}
          </option>
        </select>
      </div>
    </>
  )
}

export default MeasurementInput
